export const API_NAME = "aiQa";
export const ROUTE_NAME = "aiQa";
export const COMPONENT_NAMES = ["Ai Qa", "Ai Qas"];
